"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceClaims = exports.maintenanceClaims = exports.systemTypeClaims = exports.genesysPricingClaims = exports.genesysUserClaims = exports.contexts = void 0;
exports.contexts = {
    genesys: "munters.genesys",
    maintenance: "Munters.Genesys.Maintenance"
};
exports.genesysUserClaims = {
    login: "Login",
    developer: "Developer",
    functionTester: "FunctionTester",
    impersonate: "Impersonate",
    resetCache: "ResetCache",
    primarySalesOrganisation: "PrimarySalesOrg",
    showProductCodes: "ShowProductCodes",
    showPrices: "ShowPrices",
    showPartPrices: "ShowPartPrices",
    showLCC: "ShowLCC",
    canEnterAdvancedClimateData: "CanEnterAdvancedClimateData",
    canUseManualPerformance: "CanUseManualPerformance",
    canUseInternalFactoryNotes: "CanUseInternalFactoryNotes",
    canSeeMRC: "CanSeeMRC",
    setSystemStatusOrdered: "SetSystemStatusOrdered",
    showUsageStatistics: "ShowUsageStatistics",
    systemPsychroChart: "SystemPsychroChart",
    canUseDocFormat: "CanUseDocFormat",
    useSCBuilder: "UseSCBuilder",
    updateFromErpAll: "UpdateFromErpAll",
    updateFromErpNew: "UpdateFromErpNew",
    drySize: "DrySize",
    moistureLoadCalculation: "MoistureLoadCalculation",
    mlcSalesOrgSearch: "MLCSalesOrgSearch",
    coilPro: "CoilPro",
    fanPro: "FanPro",
    showLanguageCodes: "ShowLanguageCodes",
    showFieldDefaultUnits: "ShowFieldDefaultUnits",
    nevadaUser: "Nevada",
    salesorgsearch: "SalesOrgSearch",
    canUseSystemSelectionGuide: "CanUseSystemSelectionGuide",
    canUseDrySize: "CanUseDrySize",
    canSeeDryCap: "CanSeeDryCap",
    restrictedDeveloper: "RestrictedDeveloper",
    canUseTcoTool: "CanUseTcoTool",
    canUseTco: "CanUseTCO",
    canSeeAdvancedCoilChart: "CanSeeAdvancedCoilChart"
};
exports.genesysPricingClaims = {
    canUsePricing: "CanUsePricing",
    canSeePricing: "CanSeePricing",
    canSeePricingCost: "CanSeePricingCost",
    CanSeePricingListPrice: "CanSeePricingListPrice",
    CanSeePricingTransferPrice: "CanSeePricingTransferPrice",
    allowArticleNoEdit: "AllowArticleNoEdit",
    allowArticleNoUse: "AllowArticleNoUse",
    canSeePriceBomPricePreview: "CanSeePriceBomPricePreview"
};
exports.systemTypeClaims = {
    create: "SystemTypeCreate",
    rangeCreate: "SystemTypeRangeCreate",
    search: "SystemTypeSearch",
    calculateEnergy: "systemtypecalculateenergy",
    calculateMcompare: "systemtypecalculatemcompare",
    canUseBlackBoxComponent: "SystemTypeCanUseBlackboxComponent",
    dataCenterWizard: "DataCenterWizard"
};
exports.maintenanceClaims = {
    login: "Login",
    topLevelEdit: "TopLevelEdit",
    topLevelRead: "TopLevelRead"
};
exports.priceClaims = {
    canSeeMasterSettings: "CanSeeMasterSettings",
    canSeeProductPricePreview: "CanSeeProductPricePreview"
};
//# sourceMappingURL=constants.js.map